import { createContext, useContext } from 'react';
import { useGPSWatch } from '@conductor/modules/map-chofer/hooks/useSocketViaje';

const GPSContext = createContext({});

export const GPSProvider = ({ children }) => {
    const ubicacionGPS = useGPSWatch();

    return (
        <GPSContext.Provider value={ubicacionGPS}>
            {children}
        </GPSContext.Provider>
    );
};

export const useGPS = () => useContext(GPSContext);
